'use strict';

const releases = {
  init: function (el) {

    const form = el.querySelector('[data-releases-form]');
    if (!form) return;

    console.log('Releases form init');

    form.querySelectorAll('select').forEach(filter => {
      filter.addEventListener('change', function (_) {
        el.classList.add('loading');
        const formData = new FormData(form);
        const formProps = Object.fromEntries(formData);

        for (const key in formProps) {
          if (formProps[key] === 'all' || formProps[key] === '') {
            delete formProps[key];
          }
        }
        const queryString = new URLSearchParams(formProps as any).toString();
        window.location.href = window.location.pathname + '?' + queryString;
      })
    });

    form.addEventListener('submit', function (e) {
      el.classList.add('loading');
    })
  }
};

export default releases;
